exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".likeme-clip{width:100%;position:relative;padding-bottom:100px}.likeme-clip .splited-text{max-width:800px;margin:auto;text-align:center}@media screen and (min-width:1700px){.likeme-clip .splited-text{max-width:1200px}}@media screen and (max-width:640px){.likeme-clip .splited-text{text-align:left}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2945fc68","scoped":false,"hasInlineConfig":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/sections/badass-origins/_components/likeme-clip.vue
// module id = 547
// module chunks = 0